(() => {
  const selector = {
    slider: '.productRecommendations__content--slider',
    recommendationsSection: '.productRecommendations',
  }

  if (!customElements.get('product-recommendations')) {
    const recommendationsSection = document.querySelector(selector.recommendationsSection);
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (!html.querySelector('.productRecommendations__content').innerHTML.trim().length) {
                recommendationsSection.style.display = 'none';
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }

              $(selector.slider).slick(slickSettings);

              if (window.TrustpilotHelper) {
                window.TrustpilotHelper.loadWidgets(this);
              }
            })
            .catch(e => {
              console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);

    const slickSettings = {
      infinite: false,
      dots: true,
      arrows: false,
      autoplay: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
      ],
    };
  }
})();